<template>
  <v-container>
      <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <!--製品一覧-->
    <Content></Content>
  </v-container>
</template>

<script>
// 製品一覧コンポーネントをインポート
import Content from '../components/Products/Content'

export default {
  name: 'Products',
  components: {
    Content
  }
}
</script>
<script>
import Content from '../components/Products/Content'

export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
      {
        name: '製品情報',
        href: 'Products'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Content
  }
}
</script>
